import { Flex, Menu, MenuButton, MenuItem, MenuList, Text } from '@chakra-ui/react'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'

import Auth from '../../helpers/auth'
import { freshchatPrepareForLogout } from '../Freshchat/freshchatClient'

const Profile = () => {
  const profile = Auth.getUserProfile()
  const handleLogout = async () => {
    // Critical: clearing Freshchat while still logged in prevents the widget from crashing
    // on the next page load after logout.
    await freshchatPrepareForLogout()
    await Auth.logout()

    window.location.replace(import.meta.env.BASE_URL || '/')
  }
  return (
    <Flex align="center">
      <Menu>
        <MenuButton>
          <Flex align="center">
            <FontAwesomeIcon icon={['fad', 'user-circle']} size="lg" color="white" />
            <Text
              display={['none', 'block', 'block', 'block']}
              as="span"
              fontSize="md"
              fontWeight={400}
              color="white"
              paddingLeft="7px"
            >
              {profile && `${profile.given_name} ${profile.family_name}`}
            </Text>
          </Flex>
        </MenuButton>
        <MenuList borderColor="gray.200">
          <MenuItem onClick={() => handleLogout()}>Logout</MenuItem>
        </MenuList>
      </Menu>
    </Flex>
  )
}

export default Profile
